/**
 * Created by chachora on 12/12/18.
 */

import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import * as stApi from '../api/station-tools-api';
import { RootState } from './reducers';

export const AIRPORTS_GET = 'AIRPORTS_GET';
export const AIRPORT_SELECT = 'AIRPORT_SELECT';
export const AIRPORT_FILTER_CLEAR = 'AIRPORT_FILTER_CLEAR';

export const getAirports = (): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => async (dispatch, getState) => {
  try {
    const airports = await stApi.getAirports();
    dispatch({ type: AIRPORTS_GET, payload: { airports } });
  } catch (err) {
    throw err;
  }
};

export const selectAirport = (name: string, selected: boolean): ThunkAction<void, RootState, unknown, AnyAction> => dispatch => {
  dispatch({ type: AIRPORT_SELECT, payload: { name, selected } });
};

export const clearAirportsFilter = (): ThunkAction<void, RootState, unknown, AnyAction> => dispatch => {
  dispatch({ type: AIRPORT_FILTER_CLEAR });
};
